import React from "react";
import PencilLineArt from "./PencilLineArt";
import MicLineArt from "./MicLineArt";
import LinkLineArt from "./LinkLineArt";
import { colors } from "../../utils";

/** 16px line-art icons for Add Capture composer tabs (matches list thumbs). */
export const ComposerLineArtIcon = ({ kind, active = false, ...rest }) => {
  const color = active ? colors.PrimaryPurple700 : colors.darkGrey;
  const props = { width: 16, height: 16, color, strokeWidth: 1.75, ...rest };

  if (kind === "pencil") return <PencilLineArt {...props} />;
  if (kind === "mic") return <MicLineArt {...props} />;
  if (kind === "link") return <LinkLineArt {...props} />;
  return null;
};
